<template>
  <div>
    <!-- <button class="btn btn-primary">Job Board</button> -->
    <!-- <router-link :to="{name: 'Job Board'}" class="btn btn-primary">Job Board</router-link> -->
    <!-- {{ jobs }} -->

    <!-- <div class="row mb-3">
      <div class="col-lg-3">
        <label>Job Types</label>
        <multiselect v-model="typeFilters" :options="jobTypeOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Job Type"></multiselect>
      </div>
      <div class="col-lg-3">
        <label>Countries</label>
        <multiselect v-model="countryFilters" :options="countries" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Country"></multiselect>
      </div>
      <div class="col-lg-3">
        <label>Skills</label>
        <multiselect v-model="skillsFilters" :options="skillsOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Skills"></multiselect>
      </div>
      <div class="col-lg-3">
        <label>Topic Areas</label>
        <multiselect v-model="focusAreaFilters" :options="focusAreaOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Topic Area"></multiselect>
      </div>
    </div> -->

    <!-- <div class="row px-3">
      <div v-for="job in filteredJobs" :key="job.id" class="col-lg-4" style="border: 6px solid white; background-color: #ECCAA6;">
        <router-link :to="{ name: 'Job', params: { id: job.id } }" style="text-decoration: none; color: var(--coredarkcolor);">
          <div class="job-listing-tile mb-2" style="text-decoration: none;">

            <h3 style="margin-bottom: 0; color: black;">{{ job.title }}</h3>
            <hr>
            <p v-if="job.date">Start Date: {{ new Date(addCurrentTimeToDate(job.date)).toDateString() }}</p>
            <p v-if="job.text">Schedule: {{ job.text }}</p>
            <p>Location: {{ job.city }}, {{ job.provincestate }}, {{ job.postal_code }}</p>
            <p v-if="job.compensation">Compensation: {{ job.compensation }}</p>
            <p v-if="job.text">Schedule: {{ job.text }}</p>

          </div>
        </router-link>
      </div>
    </div> -->

    <div class="card-deck">
      <div v-for="job in filteredJobs" :key="job.id" class="col-lg-4 mb-5">
        <!-- https://stackoverflow.com/questions/38895106/how-to-limit-number-of-columns-of-card-deck -->
        <div class="card h-100">
          <!-- <router-link :to="{ name: 'Job', params: { id: job.id } }" style="text-decoration: none; color: var(--coredarkcolor);"> -->
            <img class="card-img-top" height="250px" :src="job.file1" alt="Card image cap" style="object-fit: cover;">
          <!-- </router-link> -->
          <div class="card-body">
            <router-link :to="{ name: 'Job', params: { id: job.id } }" style="text-decoration: none; color: var(--coredarkcolor);">
              <h5 class="card-title">{{ job.title }}</h5>
            </router-link>
            <!-- <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p> -->
            <p v-if="job.date">Start Date: {{ new Date(addCurrentTimeToDate(job.date)).toDateString() }}</p>
            <p v-if="job.text">Schedule: {{ job.text }}</p>
            <p v-if="job.city || job.provincestate || job.postal_code">Location: <span v-if="job.city">{{ job.city }}, </span><span v-if="job.provincestate">{{ job.provincestate }}, </span>{{ job.postal_code }}</p>
            <p v-if="job.compensation">Compensation: {{ job.compensation }}</p>
          </div>
          <router-link :to="{ name: 'Job', params: { id: job.id } }" style="text-decoration: none; color: var(--coredarkcolor);">
            <div class="card-footer">
              <small class="center">Read More</small>
            </div>
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
  import router from '../../../router'

  import PostEdit from './JobForm'

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    props: ['posterID', 'jobs'],
    data() {
      return {
        // jobs: [],
        loggedinUser: null,

        jobTypeOptions: [],
        typeFilters: [],
        skillsOptions: [],
        skillsFilters: [],
        focusAreaFilters: [],
        focusAreaOptions: [],
        countryFilters: [],
        countries: [],
      }
    },
    components: {
      appJobEdit: PostEdit,
    },
    computed: {
      filteredJobs() {
        var typeFilteredJobs = []
        if (this.typeFilters.length > 0) {
          for (var job in this.jobs) {
            if (this.typeFilters.includes(this.jobs[job].job_type)) {
              typeFilteredJobs.push(this.jobs[job])
            }
          }
        } else {
          typeFilteredJobs = this.jobs
        }

        var countryFilteredJobs = []
        if (this.countryFilters.length > 0) {
          for (var job in typeFilteredJobs) {
            if (this.countryFilters.includes(typeFilteredJobs[job].country)) {
              countryFilteredJobs.push(typeFilteredJobs[job])
            }
          }
        } else {
          countryFilteredJobs = typeFilteredJobs
        }

        var skillsFilteredJobs = []
        if (this.skillsFilters.length > 0) {
          for (var job in countryFilteredJobs) {
            // if (this.skillsFilters.every(val => countryFilteredJobs[job].skills.includes(val))) {
            //   skillsFilteredJobs.push(countryFilteredJobs[job])
            // }
            for (var skill in this.skillsFilters) {
              if (countryFilteredJobs[job].skills.includes(this.skillsFilters[skill])) {
                skillsFilteredJobs.push(countryFilteredJobs[job])
                break
              }
            }
          }
        } else {
          skillsFilteredJobs = countryFilteredJobs
        }

        var focusAreaFilteredJobs = []
        if (this.focusAreaFilters.length > 0) {
          for (var job in skillsFilteredJobs) {
            for (var focusArea in this.focusAreaFilters) {
              if (skillsFilteredJobs[job].skills2.includes(this.focusAreaFilters[focusArea])) {
                focusAreaFilteredJobs.push(skillsFilteredJobs[job])
                break
              }
            }
          }
        } else {
          focusAreaFilteredJobs = skillsFilteredJobs
        }

        return focusAreaFilteredJobs
      }
    },
    created() {
      this.loggedinUser = this.$store.getters.userID
      // this.getJobs()

      // // https://www.npmjs.com/package/vue-loading-overlay
      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.fullPage ? null : this.$refs.formContainer,
      //   // container: this.$refs.formContainer,
      //   // canCancel: true,
      //   canCancel: false,
      //   // onCancel: this.onCancel,
      // });
      // // simulate AJAX
      // setTimeout(() => {
      //   loader.hide()
      // },2000)

      this.jobTypeOptions = this.$store.getters.jobTypes
      this.skillsOptions = this.$store.getters.skills
      this.countries = this.$store.getters.countries
      this.focusAreaOptions = this.$store.getters.focusAreas

      if (this.$route.params.type && (this.$route.params.type != 'All Job Types')) {
        this.typeFilters.push(this.$route.params.type)
      }
      if (this.$route.params.country && (this.$route.params.country != 'All Countries')) {
        this.countryFilters.push(this.$route.params.country)
      }
      if (this.$route.params.topic && (this.$route.params.topic != 'All Topic Areas')) {
        this.focusAreaFilters.push(this.$route.params.topic)
      }
    },
    methods: {
      // getJobs() {
      //   if (this.posterID) {
      //     axios.get('/api/jobs?poster='.concat(this.posterID))
      //       .then(res => {
      //         this.jobs = res.data
      //       })
      //       .catch(error => console.log(error))
      //   }
      //   else {
      //     axios.get('/api/jobs/?agency=4')
      //       .then(res => {
      //         this.jobs = res.data
      //       })
      //       .catch(error => console.log(error))
      //   }
      // },
      showJob(jobID) {
        router.replace({ name: 'Job', params: { id: jobID } })
      },
      editJob(job) {
        console.log('Edit Job Icon Clicked')
        this.$emit('editJob', job) // Lecture 112
      },
    },
  }
</script>

<style>
  .job-listing-tile {
    /* background-color: var(--bootstrapgrey); */
    padding-top: 22px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    /* border: 1px solid var(--gcnorange); */
  }
</style>



// WEBPACK FOOTER //
// src/components/employers/jobs/JobList.vue